<script setup lang="ts">
import { useDungeon } from "@/stores/dungeon";
import { useGlobalUser } from "@/stores/globalUser";
import { computed, watch } from "vue";
import DesktopSpriteItem from "./DesktopSpriteItem.vue";
import { useRoute } from "vue-router";

const invalidRouteName: string[] = ["dreamHome"];

const route = useRoute();

const isInvalidRoute = computed(() => {
  return invalidRouteName.includes(route.name as string);
});

// 数据
const userStore = useGlobalUser();
const dungeoneStore = useDungeon();

const isHideStickerSprite = import.meta.env.VITE_HIDE_STICKER_SPRIT;

watch(
  () => userStore.isLogin,
  async () => {
    if (!userStore.isLogin) return false;
    await dungeoneStore.fetchDesktopSpriteList();
  },
  { immediate: true }
);

const desktopSpriteList = computed(() => dungeoneStore.desktopSpriteList);
</script>

<template>
  <div
    class="fixed top-0 left-0 w-full h-full pointer-events-none z-[1000] sprite-container"
    v-if="
      userStore.isLogin &&
      dungeoneStore.desktopSpriteList.length &&
      !isHideStickerSprite &&
      !isInvalidRoute
    "
  >
    <DesktopSpriteItem
      v-for="sprite in desktopSpriteList"
      :key="sprite.id"
      :target-sprite="sprite"
    />
  </div>
</template>
